import React from 'react';
import '../App.css'; // Your other styles if needed
import 'latex.css/dist/style.css'; // Ensure this path is correct

const Sidenote = ({ id, children }) => {
    const isEven = id % 2 === 0;
    return (
      <>
        <label htmlFor={`sn-${id}`} className="sidenote-toggle sidenote-number"></label>
        <input type="checkbox" id={`sn-${id}`} className="sidenote-toggle" />
        <span className={`sidenote${isEven ? ' left' : ''}`}>{children}</span>
      </>
    );
  };

export default Sidenote;